import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../../components/Icon/Icon";
import { IconButton } from "@mui/material";
import { colors } from "../../../styles/colors";
import { useNavigate } from "react-router";

type props = {
  sinister: TSinister;
};

export const ButtonsListSinister: FC<props> = ({ sinister }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const onClick = () => {
    navigate(`/claims/update/${sinister.id}`);
  };

  return (
    <IconButton aria-label={t("a11y.viewClaim", "View claim")} onClick={onClick}>
      <Icon name="eye" width={"24px"} height={"24px"} color={colors.BLACK} />
    </IconButton>
  );
};
